import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";
import { Button } from "@/shared/ui/button";
import type { FileItem } from "../../types";
import { TagSearchInput } from "../file-explorer/bulk-add-tags/TagSearchInput";
import { AvailableTagsList } from "../file-explorer/bulk-add-tags/AvailableTagsList";
import { useEditTags } from "./useEditTags";
import { AssignedTagsArea } from "./AssignedTagsArea";

interface EditTagsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  file: FileItem;
}

export function EditTagsDialog({
  open,
  onOpenChange,
  file,
}: EditTagsDialogProps) {
  const {
    assignedTags,
    filteredTags,
    tagsLoading,
    searchQuery,
    setSearchQuery,
    handleTagAdd,
    handleTagRemove,
    isPending,
    hasAvailableTags,
  } = useEditTags({ open, file });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] flex flex-col p-0">
        <DialogHeader className="p-6 pb-2">
          <DialogTitle>Edit Tags</DialogTitle>
          <DialogDescription>
            Add or remove tags for this file. All changes are applied
            immediately.
          </DialogDescription>
        </DialogHeader>

        <div className="flex-1 overflow-hidden flex flex-col gap-4 px-6">
          <div className="space-y-4">
            <AssignedTagsArea
              assignedTags={assignedTags}
              onRemove={handleTagRemove}
            />
            <TagSearchInput value={searchQuery} onChange={setSearchQuery} />
          </div>

          <AvailableTagsList
            tags={filteredTags}
            onAdd={handleTagAdd}
            isLoading={tagsLoading}
            searchQuery={searchQuery}
            hasAvailableTags={hasAvailableTags}
          />
        </div>

        <DialogFooter className="p-6 pt-2">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
